import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { SearchForm } from './SearchForm.js';
import { FieldGroup } from './FieldGroup.js';
import { FormControl } from './Controls/FormControl.js';
import classNames from 'classnames';
import { FAIcon } from '../fa-icon/component.js';
var _excluded = ["disabled", "name", "searchAction", "valueChangeDelay", "wrapperClass", "value"];

var SearchComponent = function SearchComponent(props) {
  var disabled = props.disabled,
      _props$name = props.name,
      name = _props$name === void 0 ? 'searchValue' : _props$name,
      searchAction = props.searchAction,
      valueChangeDelay = props.valueChangeDelay,
      wrapperClass = props.wrapperClass,
      value = props.value,
      controlProps = _objectWithoutProperties(props, _excluded);

  var inputProps = _objectSpread2(_objectSpread2({}, controlProps), {}, {
    className: classNames('ui-default', 'regular', controlProps === null || controlProps === void 0 ? void 0 : controlProps.className)
  });

  var wrapperClasses = classNames('search-wrapper', wrapperClass, {
    disabled: disabled
  });
  return /*#__PURE__*/React.createElement(SearchForm, {
    className: wrapperClasses,
    searchAction: searchAction,
    valueChangeDelay: valueChangeDelay,
    defaultValues: {
      searchValue: value
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "search-icon"
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "search"
  })), /*#__PURE__*/React.createElement(FieldGroup, {
    className: "search-input"
  }, /*#__PURE__*/React.createElement(FormControl, _extends({
    name: name,
    disableSubmit: true,
    disabled: disabled
  }, inputProps))));
};

SearchComponent.displayName = "SearchComponent";
SearchComponent.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  searchAction: PropTypes.func.isRequired,
  value: PropTypes.object,
  valueChangeDelay: PropTypes.number,
  wrapperClass: PropTypes.string,
  placeholder: PropTypes.string
};
export { SearchComponent };